import { fetchConToken } from "../helpers/fetch";

const urlBaseGet = (endpoint) => fetchConToken(`PracticasAgrupadas/${endpoint}`)
const urlBasePutPostDel = (endpoint, data, method) => fetchConToken(`PracticasAgrupadas/${endpoint}`, data, method)

const PracticasAgrupadasService = {
    //Grupos
    getGrupos: () => urlBaseGet("traer"),
    putGrupo: (id, data) => urlBasePutPostDel(id, data, "PUT"),
    postGrupo: (data) => urlBasePutPostDel('', data, "POST"),
    deleteGtupo: (id) => urlBasePutPostDel(id, {}, "DELETE"),

    //Practicas Grupo
    getPracticasGrupo: (id) => fetchConToken(`RelPracticasAgrupadasCodNom/traerPorGrupo/${id}`),
    postPracticasGrupo: (id, data) => fetchConToken(`RelPracticasAgrupadasCodNom/${id}`, data, "POST"),
    deletePracticasGrupo: (id, data) => fetchConToken(`RelPracticasAgrupadasCodNom/${id}`, data, "DELETE"),
    // removeSolicitud: (data) => fetchConToken(`SolicitudesSSS`, data, "DELETE"),
    // updateSolicitud: (idSolicitud, data) => fetchConToken(`SolicitudesSSS/${idSolicitud}`, data, "PUT"),
};

export default PracticasAgrupadasService; 